<template>
  <div id="recent-errands">
    <button
      class="btn btn-primary"
      title="Visa senaste besökta ärenden"
      @click="openModal"
    >
      <span class="fa fa-clock-o"></span>
    </button>
    <ModalWrapper
      v-if="show"
      @close-modal="show = false"
      size="md"
      :calcHeight="false"
    >
      <template #header>
        <h3>Mina senast besökta ärenden</h3>
      </template>
      <template #body>
        <Table :data="errands" :settings="tableSettings">
          <template v-slot:id="scopedData">
            <td :key="'row-' + scopedData.row.id + '-column-Key'">
              <div class="btn btn-link" @click="openErrand(scopedData.row.id)">
                {{ scopedData.row.id }}
              </div>
            </td>
          </template>
          <template v-slot:address="scopedData">
            <td :key="'row-' + scopedData.row.id + '-column-Key-address'">
              {{ scopedData.row.address }} {{ scopedData.row.city }}
            </td>
          </template>
        </Table>
        <div v-if="errands.length == 0" class="text-center">
          <strong>Du har inte besökt några ärenden än.</strong>
        </div>
      </template>
    </ModalWrapper>
  </div>
</template>

<script>
import { getErrands } from "@/helpers/localStorage";

import ModalWrapper from "@/components/Modals/ModalWrapper";
import Table from "@/components/Table";

export default {
  components: { ModalWrapper, Table },
  data() {
    return {
      show: false,
      errands: [],

      tableSettings: {
        trackRowBy: "id",
        columns: [
          {
            title: "ID",
            key: "id",
          },
          {
            title: "AO",
            key: "taskId",
          },
          {
            title: "Tjänst",
            key: "taskTypeName",
          },
          {
            title: "Senast besökt datum",
            key: "insertDate",
            filterDate: "yyyy-MM-dd HH:mm",
          },
          {
            title: "Adress",
            key: "address",
            useDashIfNull: true,
          },
        ],
      },
    };
  },
  methods: {
    openModal() {
      this.show = true;
      this.errands = getErrands();
    },
    openErrand(id) {
      this.$emit("set-errand", id);
      /*
      this.$router.replace({
        name: "home3",
        params: {
          errandId: id,
        },
      });
      */
      this.show = false;
    },
  },
};
</script>

<style lang="scss" scoped>
#recent-errands {
  font-size: 14px;
  line-height: 1.42857;
}

.fa-home {
  font-size: inherit !important;
}
</style>